import React from "react";
import {
  // convertStraight,
  // convertThenFormat,
  formatDateTime,
} from "../../common-data/Converts";
import { formatWTFString } from "../../common-data/Conversions";

const IndLeadInfo = ({ rowData }) => {
  return (
    <div className="lead-multi-value-cols">
      <div className="label-value">
        <span className="label">Lead status</span>
        <span className="value">
          {rowData?.lead_status === "pending"
            ? "Upcoming Followup"
            : rowData?.lead_status || "NA"}
        </span>
      </div>
      {/* <div className="label-value">
        <span className="label">Lead value</span>
        <span className="value">
          ₹{convertThenFormat(rowData?.lead_value || 0)}
        </span>
      </div>
      <div className="label-value">
        <span className="label">Expected closure date</span>
        <span className="value">
          {rowData?.expected_closure_date
            ? convertStraight(rowData.expected_closure_date)
            : "-"}
        </span>
      </div> */}
      <div className="label-value">
        <span className="label">Lead source</span>
        <span className="value">{formatWTFString(rowData?.source_name)}</span>
      </div>
      <div className="label-value">
        <span className="label">Assigned to</span>
        <span className="value">{rowData?.assigned_to_name || "NA"}</span>
      </div>
      <div className="label-value">
        <span className="label">Current Follow up status</span>
        <span className="value">
          {rowData?.current_followup_status
            ? rowData?.current_followup_status?.replace(/_/g, " ")
            : "NA"}
        </span>
      </div>
      {/* <div className="label-value">
        <span className="label">Plan name</span>
        <span className="value">
          {rowData?.plan_type?.replace(/_/g, " ") || "NA"}
        </span>
      </div> */}
      <div className="label-value">
        <span className="label">Added on</span>
        <span className="value">
          {rowData?.date_added ? formatDateTime(rowData.date_added) : "-"}
        </span>
      </div>
      {/* <div className="label-value">
        <span className="label">Added by</span>
        <span className="value">{rowData?.added_by_name || "NA"}</span>
      </div> */}
    </div>
  );
};

export default IndLeadInfo;
